<script>
import BackgroundVideo from '@phoenix/mixins/components/molecules/BackgroundVideo';
import { PhxIcon } from '@phx-styleguides/als';
import { PhxsgLoader } from '@sg/src/View/Components/Atoms/Loader';

export default {
  components: {
    PhxIcon,
    PhxsgLoader,
  },

  mixins: [BackgroundVideo],
};
</script>

<template>
  <div :id="videoId" class="video-player background-video">
    <video class="background-video__video" :poster="posterSrc" autoplay muted playsinline loop aria-hidden="true">
      <source :data-src="videoSrc" :type="sourceType" />
    </video>

    <button class="background-video__controls" type="button" :aria-label="$t('Accessibility.videoPlay')">
      <phx-icon icon="play" class="background-video__icon background-video__icon--play" />
      <phx-icon icon="pause" class="background-video__icon background-video__icon--pause" />
    </button>

    <phxsg-loader light size="sm" class="background-video__loader" />
  </div>
</template>
